import React from 'react';
import styled from 'styled-components/macro';
import { LandingPageDesign } from 'queries/details/usePlaybackDetailsQuery';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(29, 30, 36, 0.06);
  margin: 16px 0 0;
  width: 384px;
  border-radius: 7px;
  box-sizing: border-box;
  @media screen and (max-width: 520px) {
    margin: 0;
    border-radius: 0px;
    box-shadow: none;
    width: 100%;
  }
`;
const GoogleMapsWrapper = styled.div`
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
  margin: 16px 0 0;
  > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
`;

const Label = styled.div<{ fontSize?: number }>`
  font-weight: 600;
  font-size: 20px;
  line-height: 16px;
  color: ${props => props.theme.colors.neutral[100]};
`;

interface Props {
  mapIframeEmbedCode: string;
  landingPageDesign?: LandingPageDesign;
}

export const Map = ({ mapIframeEmbedCode, landingPageDesign }: Props) => {
  const { t } = useTranslation();
  return (
    <Wrapper className='font-roboto map-wrapper'>
      <Label fontSize={landingPageDesign?.titleFontSize}>{t('Map')}</Label>
      <GoogleMapsWrapper
        className='google-maps-wrapper'
        dangerouslySetInnerHTML={{ __html: mapIframeEmbedCode }}
      />
    </Wrapper>
  );
};
